import { memo } from 'react'
import { Images } from '../../assets/scripts/Images'
import { notAllowEnterNumber } from '../../assets/scripts/GeneralFunctions'

function ArasPlate({ aras_plate, inputHandler, isSubmit }) {
  return (
    <div
      className={
        'w-full h-16 flex border border-black dark:border-gray-700 rounded bg-white dark:bg-slate-800 dark:text-amber-50 mt-2'
      }
    >
      <div className="w-full flex items-center justify-around">
        <input
          disabled={isSubmit}
          className={
            'bg-plate rounded-md text-center w-44 h-11 dark:bg-slate-700 dark:text-amber-50 focus:outline-0'
          }
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          max={9999999}
          onKeyPress={(e) => notAllowEnterNumber(e, 7)}
          maxLength={7}
          name={'aras_plate'}
          value={aras_plate}
          onChange={inputHandler}
        />
      </div>
      <div className="bg-[#0044AA] rounded-l rounded-r-0 p-1 w-fit mr-auto flex items-center justify-center">
        <img src={Images.Aras} width={42} height={31} className={'py-1'} alt="aras flag" />
      </div>
    </div>
  )
}

export default memo(ArasPlate)
